import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {get as getRecord} from "app/requests/admin/case-submissions";
import Submission from "components/helpers/admin/case-submission";
import Loading from "components/pages/loading";

export default function AdminCaseSubmissionsShow() {
  const {id} = useParams();
  const [record, setRecord] = useState(null);

  useEffect(() => {
    getRecord(id).then((data) => setRecord(data.record));
  }, []);

  if(!record) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <h1 className="text-center">View Submission</h1>
          <Submission record={record} />
        </div>
      </div>
    </div>
  );
}
